import type { MouseEvent } from "react";
import { useGoBack } from "../../lib/navigation";

/**
 * « ← Retour » : revient à la page précédente de l'application (avec ses
 * filtres et sa position), sinon à `fallback` — la liste logique quand la page
 * a été ouverte directement. Le lien garde `fallback` pour un clic milieu.
 */
export function BackLink({
  fallback,
  className,
  label = "Retour",
}: {
  fallback: string;
  className?: string;
  label?: string;
}) {
  const goBack = useGoBack(fallback);
  const onClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)
      return;
    e.preventDefault();
    goBack();
  };
  return (
    <a href={fallback} className={className} onClick={onClick}>
      ← {label}
    </a>
  );
}
